export default function Button({ children, variant = 'primary', className = '', ...props }) {
    const variants = {
      primary: 'bg-micropoint-gold hover:bg-yellow-500 text-white',
      secondary: 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-300',
      outline: 'border-2 border-micropoint-gold text-micropoint-gold hover:bg-micropoint-gold hover:text-white',
    };
  
    return (
      <button
        className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg ${variants[variant]} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }